/**
 * The type of the advertisement slot returned by `AdSlot.getType()`.
 *
 * @remarks
 * This is primarily used by the player to determine how to play the advertisement.
 *
 * You as an integrator can use this for tracking purposes, or if you want to
 * show the type of advertisement in the UI.
 *
 * Pre-roll, mid-roll, post-roll are determined automatically by the offset,
 * unless the slot is explicitly configured as a non-linear one, which will take precedence.
 */
export const AdSlotType = {
  /**
   * Advertisement before the content.
   */
  PreRoll: 'PRE_ROLL',

  /**
   * Advertisement during the content.
   *
   * @remarks
   * The content will be paused during the advertisement.
   * There may be multiple mid-rolls.
   */
  MidRoll: 'MID_ROLL',

  /**
   * Advertisement after the content.
   */
  PostRoll: 'POST_ROLL',

  /**
   * Advertisement during the content.
   *
   * @remarks
   * The content will NOT be paused during the advertisement.
   * There may be multiple non-linear advertisements.
   */
  NonLinear: 'NON_LINEAR',
} as const;

/**
 * {@inheritDoc AdSlotType:var}
 */
export type AdSlotType = (typeof AdSlotType)[keyof typeof AdSlotType];
